export default __webpack_public_path__ + "static/wwc-image2-a62fb07922561162cd661a60f4851a5e.jpg";